import React from 'react';
import classNames from 'classnames';
import { ProductModelTopic } from '@layouts/Related/Related.types';
import { useSelectedTopic } from './TechnicalDetailsTopics.hooks';
import { ScrollableContainer } from '@components/ScrollableContainer';
import { extractTitle, getIdFromContent } from '../../TechnicalDetailsContainer.utils';
import './TechnicalDetailsTopics.scss';

interface TechnicalDetailsTagsProps {
  topics: ProductModelTopic[];
  contentRef: React.RefObject<HTMLDivElement>;
}

export const TechnicalDetailsTopics = ({ topics, contentRef }: TechnicalDetailsTagsProps) => {
  const topicIds = topics.map((topic, i) => getIdFromContent(topic.Content, i));
  const { selectedTopicId, onTopicClick } = useSelectedTopic(topicIds, contentRef);

  return (
    <ScrollableContainer className='technical-details-topics-container'>
      <div className='technical-details-topics'>
        {topics.map((topic, index) => {
          const topicId = getIdFromContent(topic.Content, index);
          const topicTitle = extractTitle(topic.Content);
          return (
            <span
              key={index}
              id={`topic-${topicId}`}
              onClick={() => onTopicClick(topicId)}
              className={classNames('technical-details-topics__tag', {
                'technical-details-topics__tag--active': selectedTopicId === topicId,
              })}
            >
              {topicTitle}
            </span>
          );
        })}
      </div>
    </ScrollableContainer>
  );
};
